import { useChecklistState } from '../../../../onboarding/checklist/useChecklistState';

/**
 * True when the song is the first release of the active artist (`onboarding.state.firstReleaseUuid`).
 * The unlock cards show only for that song (design: onboarding c5).
 */
export function useShowUnlockCards(catalogItemUuid: string): boolean {
  const { state } = useChecklistState();
  return catalogItemUuid !== '' && state?.firstReleaseUuid === catalogItemUuid;
}
